module.exports = __webpack_public_path__ + "img/become-adv-slide-1.3a5ac55.png";